import { Link } from 'react-router-dom';
import styles from './Menu.module.css';
import { useFetchData } from '../../../services/useFetchData.service';
import { Spinner } from '../../Spinner/Spinner';

export const Menu = () => {
  const { data, error } = useFetchData('/Data/HeaderMenu.json');
  if (!data) {
    return <Spinner />;
  }
  const menuItems = Object.entries(data);
  return (
    <div className={styles.menu}>
      <nav className={styles.navigation}>
        {error ? (
          <div className={styles.error}>{error}</div>
        ) : (
          menuItems.map(([name, link]) =>
            typeof link === 'string' ? (
              <Link to={link} key={name} className={styles.link}>
                {name}
              </Link>
            ) : link.type === 'other' ? (
              <a
                href={link.page}
                target="_blank"
                rel="noopener noreferrer"
                key={name}
                className={styles.link}
              >
                {name}
              </a>
            ) : null
          )
        )}
      </nav>
    </div>
  );
};
